import React from 'react'

export default function Step({ step }) {
    const steps = [1,2,3,4,5]

    return <div className="d-flex w-100" style={{ marginTop: '16px', height: '2px',  background: '#e4e4e5', borderRadius: '2px' }}>
        {steps.map((s, index) => <div key={index} className="d-flex flex-fill h-100" style={{ background: index + 1== step ? '#363636' : 'transparent', borderRadius: '2px'}}></div>)}
    </div>
}